<template>
  <div class="content-wrap">
    <el-form :inline="true">
      <el-form-item label="培训日期">
        <el-date-picker v-model="courseStartTime" type="datetime" placeholder="选择开始日期" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" @change="getStartTime"></el-date-picker>
        <el-date-picker v-model="courseEndTime" type="datetime" placeholder="选择结束日期" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" @change="getEndTime"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border highlight-current-row style="width: 100%">
      <el-table-column label="培训日期" width="340" align="center">
        <template slot-scope="scope">
          <p v-for="(l, key) in scope.row.courses">{{ l.startTime }}--{{ l.endTime }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="merchantName" label="商家（项目）" align="center"></el-table-column>
      <el-table-column label="培训老师" align="center">
        <template slot-scope="scope">
          <p v-for="(l, key) in scope.row.courses">{{ l.teacherName }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="说明" width="400" align="center"></el-table-column>
      <el-table-column label="应到人数" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.participateTjkList!=null">{{ scope.row.participateTjkList.length }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="signNum" label="签到人数" width="100" align="center"></el-table-column>
      <el-table-column prop="courseScore" label="课程评分" width="100" align="center"></el-table-column>
      <el-table-column prop="teacherScore" label="讲师评分" width="100" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="350">
        <template slot-scope="scope">
          <el-link type="primary" @click="showSign(scope.row)">发起签到</el-link>
          <el-link type="primary" @click="editRow(scope.row)">编辑课程</el-link>
          <el-link type="primary" @click="showCheckList(scope.row)">签到明细</el-link>
          <el-link type="primary" @click="gotoNameList(scope.row)">培训名单</el-link>

        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :pages="pages" :pageNum="pageNum" @getData="getList"></pagination>
    <!-- 新增培训计划 -->
    <el-dialog title="培训课程" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" :close-on-click-modal="false">
      <el-form :model="add" ref="add" label-width="120px">
        <el-form-item label="课程" class="is-required">
          <el-button type="primary" @click="addCourse">新增课程</el-button>
        </el-form-item>
        <el-form-item>
          <el-table :data="add.courses" border highlight-current-row style="width: 100%">
            <el-table-column label="培训时间" align="center" width="260">
              <template slot-scope="scope">
                {{ scope.row.startTime.substring(0, 10) }}（{{ scope.row.startTime.substring(11, 16) }}-{{ scope.row.endTime.substring(11, 16) }}）
              </template>
            </el-table-column>
            <el-table-column prop="content" label="课程内容" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="60">
              <template slot-scope="scope">
                <a class="link-text" @click="deleteCourse(scope.rowindex)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="editSubmitCourse">确 定</el-button>
      </span>
    </el-dialog>
    <!--新增课程-->
    <el-dialog title="新增课程" :visible.sync="dialogVisibleCourse" width="40%" :before-close="handleCloseCourse" :close-on-click-modal="false">
      <el-form :model="addcourse" ref="addcourse" label-width="120px">
        <el-form-item label="培训日期" prop="date">
          <el-date-picker v-model="date" type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" @change="getDateTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="时间">
          <el-time-select placeholder="起始时间" v-model="addcourse.startTime" :picker-options="{start: '00:00',step: '00:30',end: '23:00'}"></el-time-select>
          <el-time-select placeholder="结束时间" v-model="addcourse.endTime" :picker-options="{start: '00:00',step: '00:30',end: '23:00'}"></el-time-select>
        </el-form-item>
        <el-form-item label="培训内容" prop="content">
          <el-input type="textarea" v-model="addcourse.content" placeholder="请填写培训内容" autosize style="width: 500px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCourse">取 消</el-button>
        <el-button type="primary" @click="addCourseFun">确 定</el-button>
      </span>
    </el-dialog>
    <!--签到明细-->
    <el-dialog title="签到明细" :visible.sync="dialogVisibleCheck" width="50%" :before-close="handleCloseCheck" :close-on-click-modal="false">
      <el-form :model="check" ref="check">
        <el-form :inline="true">
          <el-form-item label="课程" prop="courseId">
            <el-select v-model="check.courseId" clearable placeholder="请选择">
              <el-option v-for="(t, index) in checkCourseList" :key="t.courseId" :label="t.content" :value="t.courseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否签到" prop="isNotSign">
            <el-select v-model="check.isNotSign" clearable placeholder="请选择">
              <el-option :key="true" label="未签到" :value="true"></el-option>
              <el-option :key="false" label="已签到" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getCheckList">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="checkList" border highlight-current-row style="width: 100%">
          <el-table-column prop="realName" label="姓名" width="180" align="center"></el-table-column>
          <el-table-column prop="content" label="课程内容" align="center"></el-table-column>
          <el-table-column label="签到时间" align="center">
            <template slot-scope="scope">
              <p v-for="(s, key) in scope.row.signTimes">{{ s }}</p>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="getCheckList" :current-page.sync="check.pageNum" :page-size="check.pageSize" layout="prev, pager, next, jumper" :total="check.total"></el-pagination>
      </el-form>
    </el-dialog>
    <!--发起签到弹出层-->
    <el-dialog title="发起签到" :visible.sync="dialogVisibleSign" width="40%" :before-close="handleCloseSign" :close-on-click-modal="false">
      <el-form :model="sign" ref="sign" :rules="signRules" label-width="120px">
        <el-form-item label="过期时间" prop="expireMinute">
          <el-input type="text" v-model.number="sign.expireMinute" style="width: 200px;"></el-input>分钟
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSign=false">取 消</el-button>
        <el-button type="primary" @click="signFun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      pages: 1,
      merchantId: '',
      courseStartTime: '',
      courseEndTime: '',
      list: [],
      dialogVisible: false,
      add: {
        scheduleId: null,
        courses: []
      },
      dialogVisibleCourse: false,
      date: '',
      addcourse: {
        startTime: '',
        endTime: '',
        content: ''
      },
      dialogVisibleCheck: false,
      dialogVisibleSign: false,
      sign: {
        scheduleId: '',
        expireMinute: ''
      },
      signRules: {
          expireMinute: [
              { required: true, message: '过期时间不能为空'},
              { type: 'number', message: '过期时间必须为数字'}
          ]
      },
      check: {
        scheduleId: '',
        total: 0,
        pageNum: 1,
        pageSize: 10,
        courseId: '',
        isNotSign: null
      },
      checkCourseList: [], //签到明细-课程列表
      checkList: [] //签到明细列表
    }
  },
  mounted: function () {
    document.title = '培训助手'
    this.getList(1)
  },
  methods: {
    getStartTime(date) {
      this.courseStartTime = date
    },
    getEndTime(date) {
      this.courseEndTime = date
    },
    getList(num) {
      var data = {
        'merchantId': this.merchantId,
        'courseStartTime': this.courseStartTime,
        'courseEndTime': this.courseEndTime,
        'pageNum': num,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.college + '/merchantSchedule/queryMerchantSchedule', data).then(response => {
        var result = response.data
        if(result.success) {
          this.total = result.data.total
          this.pageNum = result.data.pageNum
          this.pages = result.data.pages
          this.list = result.data.list
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //弹出层关闭-新增培训计划
    handleClose() {
      this.dialogVisible = false
      this.add.courses = []
    },
    //编辑
    editRow(obj) {
      this.add.scheduleId = obj.scheduleId
      this.dialogVisible = true
      this.add.courses = !!obj.courses ? obj.courses : []
    },
    //编辑
    showSign(obj) {
      this.sign.scheduleId = obj.scheduleId;
      this.dialogVisibleSign = true;
    },

    //编辑提交
    editSubmitCourse() {
      if(this.add.courses.length == 0) {
        this.$alert('请先新增课程')
        return
      }
      this.$http.post(API_ROOT.college + '/merchantSchedule/tjkTeacherUpdateSchedule', this.add).then(response => {
        var result = response.data
        if(result.success) {
          this.$message({
            message: '编辑成功',
            type: 'success',
            center: true,
            duration: 1000
          })
          this.handleClose()
          this.getList()
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    getDateTime(date) {
      this.date = date
    },
    //弹出层关闭-新增课程
    handleCloseCourse() {
      this.dialogVisibleCourse = false
    },
    //新增课程-弹出层
    addCourse() {
      this.dialogVisibleCourse = true
      this.date = ''
      this.addcourse.startTime = ''
      this.addcourse.endTime = ''
      this.addcourse.content = ''
    },
    //新增课程-确定
    addCourseFun() {
      if(this.date == '' || this.date == null) {
        this.$alert('请选择日期')
        return
      }
      if(this.addcourse.startTime == '' || this.addcourse.startTime == null) {
        this.$alert('请选择开始时间')
        return
      }
      if(this.addcourse.endTime == '' || this.addcourse.endTime == null) {
        this.$alert('请选择结束时间')
        return
      }
      var start = new Date(this.date + ' '+ this.addcourse.startTime + ':00').valueOf()
      var end = new Date(this.date + ' '+ this.addcourse.endTime + ':00').valueOf()
      if(end < start) {
        this.$alert("结束时间不能小于开始时间")
        return
      }
      if(this.addcourse.content == '' || this.addcourse.content == null) {
        this.$alert('请填写课程内容')
        return
      }
      this.addcourse.startTime = this.date + ' '+ this.addcourse.startTime + ':00'
      this.addcourse.endTime = this.date + ' '+ this.addcourse.endTime + ':00'
      this.add.courses.push(JSON.parse(JSON.stringify(this.addcourse)))
      this.dialogVisibleCourse = false
    },
    //删除课程
    deleteCourse(key) {
      this.add.courses.splice(key, 1)
    },
    //签到明细-弹出层显示
    showCheckList(obj) {
      this.dialogVisibleCheck = true
      this.check.scheduleId = obj.scheduleId
      this.checkCourseList = obj.courses
      this.getCheckList()
    },
    gotoNameList(obj){
      var scheduleId = obj.scheduleId;
      window.location.href="/tjkStudy/traincheck/namelist?scheduleId=" + scheduleId;
    },
    //签到明细-弹出层关闭
    handleCloseCheck() {
      this.dialogVisibleCheck = false
      this.check.total = 0
      this.check.pageNum = 1
      this.check.pageSize = 10
      this.check.courseId = ''
      this.check.isNotSign = null
      this.checkCourseList = []
      this.checkList = []
    },
    //签到明细
    getCheckList() {
      this.$http.post(API_ROOT.college + '/merchantSchedule/querySignRecordByScheduleId', this.check).then(response => {
        var result = response.data
        if(result.success) {
          this.check.total = result.data.total
          this.checkList = result.data.list
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //发起签到弹出层-关闭
    handleCloseSign() {
      this.sign.scheduleId = ''
      this.sign.expireMinute = ''
      this.dialogVisibleSign = false
    },
    //发起签到-确认
    signFun() {
        var self = this;
        this.$refs.sign.validate((valid) => {
        if(valid) {
          //tjk也需要签到，为不受登录token困扰，末尾传jumpToken=true
          self.$http.post(API_ROOT.college + '/merchantSchedule/tjkSetSignExpireTime?jumpToken=true', self.sign).then(response => {
            var result = response.data
            if(result.success) {
              self.$message({
                message: '操作成功',
                type: 'success',
                center: true,
                duration: 1000
              })
              self.handleCloseSign()
            }else {
              self.$alert(result.msg)
            }
          }, response => {
            self.$alert('网络繁忙，请稍后重试！')
          })
        }else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  padding: 20px;
}
.el-pagination {
  text-align: center;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/trainCheck/trainList.vue